import { warn } from '@execonline-inc/logging';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import ReactionComponent, { RCProps } from '../../../ReactionComponent';
import CountStore from '.';
import { CountError, State } from './Types';

interface Props extends RCProps<CountStore> {
  count: () => Task<CountError, number>;
}

const countUnavailable = (store: CountStore) => (error: CountError) => {
  warn('PeopleV2 CountReactions', error.kind, error);
  store.unavailable();
};

class CountReactions extends ReactionComponent<CountStore, State, Props> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store, count } = this.props;
    switch (state.kind) {
      case 'loading':
        count().fork(countUnavailable(store), store.ready);
        break;
      case 'ready':
      case 'unavailable':
        break;
      default:
        assertNever(state);
    }
  };
}

export default CountReactions;
